var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("connection-settings-popup", {
    attrs: {
      resources: {
        deletePromptTitle: _vm.resource(
          "JourneyBuilder_FilterExclusionSettings_Delete_Title"
        ),
        deletePromptBody: _vm.resource(
          "JourneyBuilder_FilterExclusionSettings_Delete_Body"
        )
      },
      "comment-id": _vm.commentId
    },
    on: {
      save: function($event) {
        return _vm.save()
      },
      delete: function($event) {
        return _vm.deleteCheckpoint()
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "w-100" },
              [
                _c("h3", { staticClass: "d-inline-block mr-1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.resource(
                        "JourneyBuilder_FilterExclusionSettings_Title"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("help-popover", {
                  attrs: {
                    content: _vm.resource(
                      "JourneyBuilder_FilterExclusionSettings_Explanation"
                    )
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "row form-group" }, [
              _c("div", { staticClass: "col-12 text-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary",
                    on: {
                      click: function($event) {
                        return _vm.openFilterSettings()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-pencil-alt mr-1" }),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_FilterExclusionSettings_Button_EditFilters"
                          )
                        )
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.filters, function(filterGroup) {
              return [
                _c(
                  "div",
                  {
                    key: filterGroup.id,
                    staticClass: "row form-group no-gutters filter-group"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "col-2" },
                      [
                        _vm.enableTogglingFilterExclusionGroups
                          ? _c("toggle-button", {
                              staticClass: "mt-3",
                              attrs: {
                                value: !_vm.isFilterExcluded(filterGroup.id)
                              },
                              on: {
                                input: function($event) {
                                  return _vm.toggleFilterExclusion(
                                    filterGroup.id,
                                    !$event
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-10" },
                      _vm._l(filterGroup.children, function(filter) {
                        return _c("brick-filter-condition", {
                          attrs: { field: filter.field, value: filter.value }
                        })
                      }),
                      1
                    )
                  ]
                )
              ]
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }